module.exports = __webpack_public_path__ + "static/media/antiwrinklecream.78ccc584.png";